import { api, ReactQueryOptions, RouterInputs } from '@api'

type inputType = RouterInputs['BlindBoxManager']['getSingle']
type queryOptionsType = ReactQueryOptions['BlindBoxManager']['getSingle']

export const useGetSingleBlindBox = (input: inputType, options?: queryOptionsType) => {
    return api.BlindBoxManager.getSingle.useQuery(input, {
        ...options,
        queryKey: ['BlindBoxManager.getSingle', input],
        staleTime: 15 * 60 * 1000, // 15 mins
    })
}
